namespace Matrix.Indexation {
    export interface FactIndexRorRow {
        IndexationProfileKey?: number;
        IndexKey?: number;
        BaseDate?: string;
        EffectiveDate?: string;
        SourceCode?: string;
        IndexRor?: number;
        PriceIndex?: number;
        IndexCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IndexCode?: string;
        IndexName?: string;
        IndexGeneration?: number;
        IndexIsCurrent?: string;
        IndexEffectiveFrom?: string;
        IndexEffectiveTo?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        SourceName?: string;
        SourceGroup?: string;
        SourceCategory?: string;
        SourceId?: number;
        SourceRowId?: number;
        IndexCurrencyName?: string;
        IndexCurrencyRowId?: number;
        IndexCurrencyDefaultSortOrder?: number;
    }

    export namespace FactIndexRorRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.FactIndexRor';
        export const deletePermission = 'DataAdmin:FactIndexRor';
        export const insertPermission = 'DataAdmin:FactIndexRor';
        export const readPermission = 'Read:FactIndexRor';
        export const updatePermission = 'DataAdmin:FactIndexRor';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            IndexKey = "IndexKey",
            BaseDate = "BaseDate",
            EffectiveDate = "EffectiveDate",
            SourceCode = "SourceCode",
            IndexRor = "IndexRor",
            PriceIndex = "PriceIndex",
            IndexCurrency = "IndexCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IndexCode = "IndexCode",
            IndexName = "IndexName",
            IndexGeneration = "IndexGeneration",
            IndexIsCurrent = "IndexIsCurrent",
            IndexEffectiveFrom = "IndexEffectiveFrom",
            IndexEffectiveTo = "IndexEffectiveTo",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            SourceName = "SourceName",
            SourceGroup = "SourceGroup",
            SourceCategory = "SourceCategory",
            SourceId = "SourceId",
            SourceRowId = "SourceRowId",
            IndexCurrencyName = "IndexCurrencyName",
            IndexCurrencyRowId = "IndexCurrencyRowId",
            IndexCurrencyDefaultSortOrder = "IndexCurrencyDefaultSortOrder"
        }
    }
}
